<script lang="ts">
    export let name:string;
    export let label:string;
    export let checked:boolean = false;
    export let disabled:boolean = false;

    import { createEventDispatcher } from 'svelte';

    let htmlName = name.toLowerCase().replace(/\s/g, '-');

    const dispatch = createEventDispatcher();
    function inputChange() {
		dispatch('message', {
			text: 'Hello, checkbox change!',
            checked: checked
		});
    }


</script>

<div class="checkbox-area">
    <div class="checkbox-option" class:disabled="{disabled}">
        <label for={htmlName}>
            <input type="checkbox" id={htmlName} name={htmlName} on:change={inputChange} bind:checked={checked} disabled={disabled}/>
            {label}
        </label>
    </div>
</div>


<style>
    .checkbox-area {
        display: flex;
        flex-direction: column;
        /* margin-bottom: 2rem; */
    }
    .checkbox-option {
        margin-right: 1rem;
        border-radius: 8px;
    }
    .checkbox-option:hover {
        background: var(--background-offset);
    }
    input {
        background: var(--background);
        width: 1.5rem;
        height: 1.5rem;
        padding: 1rem;
        margin: 0 0.5rem 0 0;
        border: 2px solid var(--text);
    }
    .disabled {
        cursor: not-allowed;
        color: var(--text-disabled);
    }
    .disabled.checkbox-option:hover {
        background-color: unset;
    }
    label {
        display: flex;
        padding: 1rem 1rem 1rem 0;
        align-items: center;
    }
    

</style>